import { DeleteIcon } from "components/common/Icons/DeleteIcon";
import { Select } from "components/common/Select/Select";
import { Slider } from "components/common/Slider/Slider";
import { getDefaultPaddingColors } from "store/features/memeGenerator/data/getDefaultPaddingColors";
import { paddingKeysList, paddingNamesObject } from "store/features/memeGenerator/data/paddingNames";
import { usePadding } from "./usePadding";

export const Padding = () => {
    const {
        padding,
        dominantColor,
        handlePaddingOptionClick,
        handlePaddingColorClick,
        handlePaddingValue,
        handleDelete,
    } = usePadding();
    if (!padding?.isApplied) return null;
    return (
        <div className="px-6 py-3 flex flex-col gap-4">
            <div className="flex items-center justify-between gap-2">
                <div className="w-full">
                    <Select
                        options={paddingKeysList}
                        getOptionLabel={(key) => paddingNamesObject[key]}
                        getOptionValue={(key) => key}
                        value={padding.type}
                        handleClick={handlePaddingOptionClick}
                    />
                </div>
                <div className="w-full">
                    <Select
                        options={getDefaultPaddingColors(dominantColor ?? "#000")}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.color}
                        value={padding.color}
                        handleClick={handlePaddingColorClick}
                    />
                </div>
            </div>
            <div className="flex items-stretch gap-2">
                <div className="flex items-center gap-4 border border-irGray-200 dark:border-darkSurface-400 px-4 pt-2 pb-3 rounded-xl flex-grow">
                    <div className="flex-grow">
                        <Slider
                            min={0}
                            max={100}
                            defaultValue={padding.value}
                            handleChange={handlePaddingValue}
                            step={1}
                        />
                    </div>
                    <div className="mt-1">{padding.value}%</div>
                </div>
                <button
                    className="group flex items-center justify-center px-4 border border-irGray-200 dark:border-darkSurface-400 rounded-xl hover:bg-irRed-400 dark:hover:bg-darkSurface-200"
                    onClick={handleDelete}
                >
                    <DeleteIcon className="fill-irRed-400 group-hover:fill-white" />
                </button>
            </div>
        </div>
    );
};
